import type * as React from 'react';

import { Icon } from '@gitbook/spine-icons';
import {
    Button,
    Description,
    EmptyState,
    EmptyStateActions,
    EmptyStateIcon,
    EmptyStateNotFoundHeading,
} from '@gitbook/spine-react';

/**
 * Full-screen component when the space doesn't exist or has been hard-deleted.
 */
export function SpaceNotFound(): React.ReactElement {
    return (
        <EmptyState>
            <EmptyStateIcon>
                <Icon.Space />
            </EmptyStateIcon>
            <EmptyStateNotFoundHeading />
            <Description>
                The space you are trying to access doesn't exist or may have been deleted.
            </Description>
            <EmptyStateActions>
                <Button
                    kind="secondary"
                    size="medium"
                    href={{ screen: { type: 'home' } }}
                    label="Take me home"
                />
            </EmptyStateActions>
        </EmptyState>
    );
}
